const host = window.location.host
let baseUrl = ''

if (host === 'localhost:8900') {
  baseUrl = '/api'  //测试
} else {
  // baseUrl = '/api'  //本地
  // baseUrl = 'http://lpz.goodseller.cn'  //测试
  // baseUrl = 'https://www.gzyf678.com'  //生产
}
export default baseUrl
